import { render, staticRenderFns } from "./award-dialog.vue?vue&type=template&id=1cf91a5a&scoped=true&"
import script from "./award-dialog.vue?vue&type=script&lang=js&"
export * from "./award-dialog.vue?vue&type=script&lang=js&"
import style0 from "./award-dialog.vue?vue&type=style&index=0&id=1cf91a5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf91a5a",
  null
  
)

export default component.exports